export default __webpack_public_path__ + "static/media/PH-webinar certificate.50dbac3a.png";